// src/store/actions/appActions.js

import axiosInstance from "../../api/axiosInstance";
import {
  CH_ONDC_AES_KEY,
  formSubmitUrl,
  getCitygeUrl,
  getHeritageUrl,
  getServiceUrl,
  initializePaymentUrl,
  paymentDetailsUrl,
  PreviousBookingUrl
} from "../../utills/constants";
import { AesECBEncrypt } from "../../utills/encryption";

/* -------------------------------------------------
   BOOKING FORM ACTIONS
------------------------------------------------- */
export const SUBMIT_BOOKING_FORM_REQUEST = "SUBMIT_BOOKING_FORM_REQUEST";
export const SUBMIT_BOOKING_FORM_SUCCESS = "SUBMIT_BOOKING_FORM_SUCCESS";
export const SUBMIT_BOOKING_FORM_FAILURE = "SUBMIT_BOOKING_FORM_FAILURE";
export const SET_CHECKSUM = "SET_CHECKSUM";

export const submitBookingFormRequest = () => ({ type: SUBMIT_BOOKING_FORM_REQUEST });
export const submitBookingFormSuccess = (data) => ({ type: SUBMIT_BOOKING_FORM_SUCCESS, payload: data });
export const submitBookingFormFailure = (error) => ({ type: SUBMIT_BOOKING_FORM_FAILURE, payload: error });

export const submitBookingForm = (formData) => async (dispatch) => {
  dispatch(submitBookingFormRequest());
  const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, formData);

  try {
    const response = await axiosInstance.post(formSubmitUrl(), encryptedBody);
    if (response?.status === 200) {
      dispatch(submitBookingFormSuccess(response.data));
    } else {
      dispatch(submitBookingFormFailure(response.data?.message || "Submission failed"));
    }
  } catch (error) {
    dispatch(
      submitBookingFormFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

export const setChecksum = (checksum) => ({ type: SET_CHECKSUM, payload: checksum });

/* -------------------------------------------------
   CITIES ACTIONS
------------------------------------------------- */
export const FETCH_CITIES_REQUEST = "FETCH_CITIES_REQUEST";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAILURE = "FETCH_CITIES_FAILURE";
export const SET_SELECTED_CITY = "SET_SELECTED_CITY";

export const fetchCities = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CITIES_REQUEST });
    const { data } = await axiosInstance.get(getCitygeUrl());
    dispatch({ type: FETCH_CITIES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_CITIES_FAILURE, payload: error.message });
  }
};

export const setSelectedCity = (city) => ({ type: SET_SELECTED_CITY, payload: city });

/* -------------------------------------------------
   HERITAGES ACTIONS
------------------------------------------------- */
export const FETCH_HERITAGES_REQUEST = "FETCH_HERITAGES_REQUEST";
export const FETCH_HERITAGES_SUCCESS = "FETCH_HERITAGES_SUCCESS";
export const FETCH_HERITAGES_FAILURE = "FETCH_HERITAGES_FAILURE";

export const fetchHeritages = (data) => async (dispatch) => {
  dispatch({ type: FETCH_HERITAGES_REQUEST });
  const fixedTime = "T12:00:00.000Z";
  const body = {
    start_time: data?.selectedDate + fixedTime,
    end_time: data?.selectedDate + fixedTime,
    city_code: data?.id,
  };

  const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, body);

  try {
    const response = await axiosInstance.post(getHeritageUrl(), encryptedBody);
    dispatch({ type: FETCH_HERITAGES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_HERITAGES_FAILURE,
      payload: error.message || "Something went wrong",
    });
  }
};

/* -------------------------------------------------
   HERITAGE BOOKING ACTIONS
------------------------------------------------- */
export const FETCH_HERITAGE_BOOKING_REQUEST = "FETCH_HERITAGE_BOOKING_REQUEST";
export const FETCH_HERITAGE_BOOKING_SUCCESS = "FETCH_HERITAGE_BOOKING_SUCCESS";
export const FETCH_HERITAGE_BOOKING_FAILURE = "FETCH_HERITAGE_BOOKING_FAILURE";
export const RESET_HERITAGE_BOOKING_LOADING = "RESET_HERITAGE_BOOKING_LOADING";

export const resetHeritageBookingLoading = () => ({ type: RESET_HERITAGE_BOOKING_LOADING });

export const getHeritageBooking = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_HERITAGE_BOOKING_REQUEST });
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(getServiceUrl(), encryptedBody);
    dispatch({ type: FETCH_HERITAGE_BOOKING_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_HERITAGE_BOOKING_FAILURE,
      payload: error?.response?.data || "Something went wrong",
    });
    throw error;
  }
};

/* -------------------------------------------------
   INITIALIZE PAYMENT ACTIONS
------------------------------------------------- */
export const INIT_PAYMENT_API_REQUEST = "INIT_PAYMENT_API_REQUEST";
export const INIT_PAYMENT_API_SUCCESS = "INIT_PAYMENT_API_SUCCESS";
export const INIT_PAYMENT_API_FAILURE = "INIT_PAYMENT_API_FAILURE";

export const initializePayment = (payload, paymentMode) => async (dispatch) => {
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    dispatch({ type: INIT_PAYMENT_API_REQUEST });
    const response = await axiosInstance.post(initializePaymentUrl(paymentMode), encryptedBody);
    dispatch({ type: INIT_PAYMENT_API_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: INIT_PAYMENT_API_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
};

/* -------------------------------------------------
   PAYMENT ACTIONS
------------------------------------------------- */
export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAILURE = "PAYMENT_FAILURE";

export const paymentRequest = () => ({ type: PAYMENT_REQUEST });
export const paymentSuccess = (data) => ({ type: PAYMENT_SUCCESS, payload: data });
export const paymentFailure = (error) => ({ type: PAYMENT_FAILURE, payload: error });

export const initiatePayment = (bookingData) => async (dispatch) => {
  dispatch(paymentRequest());
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, bookingData);
    const response = await axiosInstance.post(paymentDetailsUrl(), encryptedBody);

    if (response.data) {
      dispatch(paymentSuccess(response.data));
    } else {
      dispatch(paymentFailure(response.data?.message || "Payment failed"));
    }
  } catch (error) {
    dispatch(
      paymentFailure(error.response?.data?.message || error.message || "Something went wrong")
    );
  }
};
/* -------------------------------------------------
   PREVIOUS BOOKINGS ACTIONS
------------------------------------------------- */
export const FETCH_PREVIOUS_BOOKINGS_REQUEST = "FETCH_PREVIOUS_BOOKINGS_REQUEST";
export const FETCH_PREVIOUS_BOOKINGS_SUCCESS = "FETCH_PREVIOUS_BOOKINGS_SUCCESS";
export const FETCH_PREVIOUS_BOOKINGS_FAILURE = "FETCH_PREVIOUS_BOOKINGS_FAILURE";


export const fetchPreviousBookings = () => async (dispatch) => {
  console.log("sksk1");
  dispatch({ type: FETCH_PREVIOUS_BOOKINGS_REQUEST });
  try {
     console.log("sksk1");
    const response = await axiosInstance.get(PreviousBookingUrl());
    if (response?.data?.status === "success" && Array.isArray(response?.data?.data)) {
      console.log("sksk",response );
      dispatch({ type: FETCH_PREVIOUS_BOOKINGS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: FETCH_PREVIOUS_BOOKINGS_SUCCESS, payload: [] });
    }
  } catch (error) {
    dispatch({
      type: FETCH_PREVIOUS_BOOKINGS_FAILURE,
      payload: error.response?.data?.message || error.message || "Something went wrong",
    });
  }
};
